import { z } from 'zod';
import { BaseStatFilterSchema } from '../../../schemas';
import { useTHPTChartQuery } from './useTHPTQuery';

interface UseTHPTChartParams {
	filters?: z.infer<typeof BaseStatFilterSchema>;
}

export function useTHPTChart(params?: UseTHPTChartParams) {
	const { data: nivoData, isLoading, error } = useTHPTChartQuery(params);

	return {
		nivoData: nivoData?.data || null,
		isLoading,
		error
	};
}
